import type { OnInit } from '@angular/core';
import { Component, Inject, Input } from '@angular/core';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { EnvironmentConfig } from '@core/config-models';
import { getSiteContext } from '@analytics/utils';
import type { State } from '@core/jss-routing';
import type { InnogyComponentRendering } from '@core/jss-models';
import { getFieldValue, getItemLinkFieldValue } from '@core/jss-utils';
import { Store } from '@ngrx/store';
import type { LinkField } from '@sitecore-jss/sitecore-jss-angular';
import { NgClass, AsyncPipe } from '@angular/common';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { TrackImpressionDirective } from '@analytics/events';
import {
  ExperienceEditorComponent,
  ExperienceEditorLiveDirective,
  ExperienceEditorPreviewDirective,
} from '@core/experience-editor-components';

import type { ButtonModel } from '../button.model';
import { ButtonComponent } from '../button.component';

@Component({
  selector: 'wl-button-container',
  templateUrl: './button-container.component.html',
  styleUrls: ['./button-container.component.scss'],
  standalone: true,
  imports: [
    ExperienceEditorComponent,
    ExperienceEditorLiveDirective,
    ExperienceEditorPreviewDirective,
    ButtonComponent,
    TrackImpressionDirective,
    NgClass,
    JssModule,
    AsyncPipe,
  ],
})
export class ButtonContainerComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering: InnogyComponentRendering | undefined;

  config?: ButtonModel;
  placement$ = getSiteContext(this.store$, this.environmentConfig);

  constructor(
    private readonly store$: Store<State>,
    @Inject(ENVIRONMENT_CONFIG)
    private readonly environmentConfig: EnvironmentConfig
  ) {}

  ngOnInit() {
    this.config = this.renderingToModel(this.rendering);
  }

  public renderingToModel(
    rendering: InnogyComponentRendering | undefined
  ): ButtonModel {
    if (rendering == null || rendering.fields == null) {
      return {};
    }

    const text = getFieldValue<string>(rendering.fields, 'text');
    const cssClass = getItemLinkFieldValue(rendering.fields, 'class');
    const icon = getFieldValue<string>(rendering.fields, 'icon');
    const url = getFieldValue<LinkField>(rendering.fields, 'url');

    return {
      text,
      class: cssClass,
      icon,
      url: url ? url.href : '',
    };
  }
}
